<div class="modal-propriete">
  <app-dialog-simple
    [textContent]="{
      title: 'pop-up.supprimer-propriete.titre',
      titleId: 'delete-popup-titre',
      confirmButton: 'btn.supprimer',
      confirmButtonId: 'btn-oui',
      cancelButton: 'btn.annuler',
      cancelButtonId: 'btn-non'
    }"
    (close)="close()"
    (confirm)="delete()"
  >
  </app-dialog-simple>
</div>
